module.exports = __webpack_public_path__ + "img/sonrisa.1e6d9e28.png";